export const conversionStatusMap: { [key: string]: string } = {
  '1': 'active',
  '2': 'pending',
}
